import { CSSProperties } from '@material-ui/styles';
import React from 'react';
import './style.scss';

interface Props {
    iconName: string;
    message: string;
    style?: CSSProperties;
    outlined?: boolean;
}

const EmptySection: React.FC<Props> = ({ iconName, message, style, outlined = true }: Props) => (
    <div className="empty-section" style={style}>
        <div className="empty-content">
            <i className={`material-icons${outlined ? '-outlined' : ''} icon-center icon`}>{iconName}</i>
            <h1>{message}</h1>
        </div>
    </div>
);

export default EmptySection;
